import React, { useState } from 'react';
import { string, elementType, func, bool } from 'prop-types';
import { Box, ModalActionsStyled, TextStyled, useTokens } from '@nike/nike-design-system-components';
import { StyledDialog } from './styles';
import LoadingOverlay from '../components/LoadingOverlay';

const Modal = ({ isOpen, closeModal, title = '', content, footer, headerTitleSlot, unwrapped = false, ...rest }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const tokens = useTokens();

  /**
   * Toggles the loading state.
   * Passing a message will show the message if the loading state WILL be true.
   * @param {string} message
   */
  const toggleIsLoading = (value, message) => {
    setIsLoading(value);

    if (message) {
      setLoadingMessage(message);
    }
  };

  const header = headerTitleSlot && (
    <Box width='130%' paddingBlockEnd='12px' style={{ borderBottom: `1px solid ${tokens.podiumCdsColorGrey300}` }}>
      <TextStyled appearance='title2'>{headerTitleSlot.title}</TextStyled>
      <TextStyled appearance='body2' color={tokens.podiumCdsColorGrey500}>
        {headerTitleSlot.subtitle}
      </TextStyled>
    </Box>
  );

  const actions = footer && (
    <ModalActionsStyled>{footer({ isLoading, toggleIsLoading, setIsLoading })}</ModalActionsStyled>
  );

  const enhancedContent = (
    <>
      <LoadingOverlay isVisible={isLoading} message={loadingMessage} />
      {/* Render as a div: content may contain block elements (forms, divs) that are invalid inside a <p> */}
      <TextStyled appearance='body2' Component='div' style={{ paddingBottom: '10px' }}>
        {content({ isLoading, toggleIsLoading })}
      </TextStyled>
    </>
  );

  return (
    <StyledDialog
      isOpen={isOpen}
      title={title}
      closeModal={closeModal}
      slots={{ HeaderTitleSlot: header, FooterSlot: actions }}
      backdropCompProps={{ style: { backdropFilter: 'blur(4px)' } }}
      {...rest}
    >
      {unwrapped ? (
        enhancedContent
      ) : (
        <div className='flex-container relative-container' style={{ alignItems: 'start' }}>
          {enhancedContent}
        </div>
      )}
    </StyledDialog>
  );
};

Modal.propTypes = {
  closeModal: func.isRequired,
  isOpen: bool.isRequired,
  title: string,
  headerTitleSlot: string,
  content: elementType.isRequired,
  footer: elementType,
  unwrapped: bool
};

Modal.defaultProps = {
  footer: undefined,
  title: '',
  headerTitleSlot: '',
  unwrapped: false
};

export default Modal;
